import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import { SuggestActionsData, SuggestedAction } from '../tool-content.model';

/**
 * Renders actionable suggestion cards for next-step recommendations.
 */
@Component({
  selector: 'app-ai-suggest-actions',
  templateUrl: './ai-suggest-actions.component.html',
  styleUrls: ['./ai-suggest-actions.component.scss'],
  imports: [AppSharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiSuggestActionsComponent {
  readonly data = input.required<SuggestActionsData>();
  readonly actionClicked = output<SuggestedAction>();

  protected readonly title = computed(() => this.data().title);
  protected readonly actions = computed(() => this.data().actions);
  protected readonly hasActions = computed(() => this.actions().length > 0);

  protected actionIcon(action: SuggestedAction): string {
    switch (action.actionType) {
      case 'show_chart':
        return 'bar_chart';
      case 'show_table':
        return 'table_chart';
      case 'show_metrics':
        return 'insights';
      case 'show_documents':
        return 'description';
      case 'summarize_findings':
        return 'summarize';
      case 'driver_analysis':
        return 'insights';
      case 'compare_segments':
        return 'compare_arrows';
      default:
        return 'lightbulb';
    }
  }
}
